(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-contact-success"] && !Shopify.designMode) return;
  try {
    (function () {
    function close(dialog) {
      if (dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-closing');

      var settled = false;
      var finish = function (event) {
        if (event && event.target !== dialog) return;
        if (settled) return;
        settled = true;
        dialog.removeEventListener('animationend', finish);
        clearTimeout(timer);
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      var timer = setTimeout(finish, 900);
      dialog.addEventListener('animationend', finish);
    }

    function setup(dialog) {
      if (dialog.dataset.plCsReady === 'true') return;
      dialog.dataset.plCsReady = 'true';

      dialog.querySelectorAll('[data-pl-cs-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          close(dialog);
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) close(dialog);
      });

      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        close(dialog);
      });

      if (!dialog.open) dialog.showModal();
    }

    function init() {
      document.querySelectorAll('[data-pl-contact-success]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-favorites"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'pl_favorites';
    const EMAIL_KEY = 'pl_favorites_email';
    const EVENT = 'pl:favorites:change';
    const SELECTOR = '[data-pl-fav]';
    const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    let pendingHandle = null;

    const readList = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    };

    const writeList = (handles) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(handles));
        return true;
      } catch (error) {
        return false;
      }
    };

    const readEmail = () => {
      try {
        return localStorage.getItem(EMAIL_KEY) || '';
      } catch (error) {
        return '';
      }
    };

    const writeEmail = (email) => {
      try {
        localStorage.setItem(EMAIL_KEY, email);
      } catch (error) {
        /* private mode — the popup simply asks again next visit */
      }
    };

    const syncAll = () => {
      const handles = readList();
      const count = handles.length;

      document.querySelectorAll(SELECTOR).forEach((el) => {
        const on = handles.indexOf(String(el.dataset.plFav)) !== -1;
        el.classList.toggle('is-fav', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        const label = on ? el.dataset.labelRemove : el.dataset.labelAdd;
        if (label) el.setAttribute('aria-label', label);
      });

      document.querySelectorAll('[data-pl-fav-count]').forEach((el) => {
        const next = String(count);
        if (el.textContent !== next) el.textContent = next;
      });

      document.querySelectorAll('[data-pl-fav-link]').forEach((el) => {
        el.toggleAttribute('hidden', count === 0);
      });

      document.dispatchEvent(new CustomEvent(EVENT, { detail: { handles, count } }));
    };

    const commit = (handle) => {
      const handles = readList();
      const index = handles.indexOf(handle);
      if (index === -1) {
        handles.unshift(handle);
      } else {
        handles.splice(index, 1);
      }
      if (writeList(handles)) syncAll();
    };

    const getModal = () => document.getElementById('pl-fav-modal');

    const closeModal = () => {
      const modal = getModal();
      pendingHandle = null;
      if (modal && modal.open) modal.close();
    };

    const openModal = (handle) => {
      const modal = getModal();
      if (!modal || typeof modal.showModal !== 'function') {
        commit(handle);
        return;
      }

      pendingHandle = handle;
      const input = modal.querySelector('[data-pl-fav-input]');
      const error = modal.querySelector('[data-pl-fav-error]');
      if (input) input.value = '';
      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
      if (!modal.open) modal.showModal();
      if (input) requestAnimationFrame(() => input.focus());
    };

    const submitEmail = (value) => {
      const email = String(value || '').trim().toLowerCase();
      const modal = getModal();
      const error = modal ? modal.querySelector('[data-pl-fav-error]') : null;

      if (!EMAIL_PATTERN.test(email)) {
        if (error) {
          error.textContent = error.dataset.message || '';
          error.hidden = false;
        }
        return;
      }

      writeEmail(email);
      const handle = pendingHandle;
      closeModal();
      if (handle) commit(handle);
    };

    const toggle = (handle) => {
      const key = String(handle || '').trim();
      if (!key) return;
      if (readList().indexOf(key) === -1 && !readEmail()) {
        openModal(key);
        return;
      }
      commit(key);
    };

    const activate = (event) => {
      const el = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!el) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      toggle(el.dataset.plFav);
    };

    document.addEventListener('click', activate);
    document.addEventListener('keydown', activate);

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-pl-fav-close]')) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (target.id !== 'pl-fav-modal') return;
      const rect = target.getBoundingClientRect();
      const outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;
      if (outside) closeModal();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest ? event.target.closest('[data-pl-fav-form]') : null;
      if (!form) return;
      event.preventDefault();
      const input = form.querySelector('[data-pl-fav-input]');
      submitEmail(input ? input.value : '');
    });

    document.addEventListener(
      'close',
      (event) => {
        if (event.target && event.target.id === 'pl-fav-modal') pendingHandle = null;
      },
      true
    );

    window.addEventListener('storage', (event) => {
      if (event.key === KEY) syncAll();
    });

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncAll();
      });
    });

    const start = () => {
      syncAll();
      observer.observe(document.body, { childList: true, subtree: true });
    };

    window.PLFavorites = {
      handles: readList,
      count: () => readList().length,
      isFavorite: (handle) => readList().indexOf(String(handle)) !== -1,
      toggle,
      sync: syncAll,
    };

    if (document.body) {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-nav-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var drawer = document.getElementById('pl-nav-drawer');
      if (!drawer || drawer.dataset.plInit === '1') return;
      drawer.dataset.plInit = '1';

      var overlay = document.querySelector('[data-pl-drawer-overlay]');
      var trigger = document.querySelector('.header__icon--menu');
      // The hamburger <-> X swap is Horizon's, keyed on `.menu-open` on the enclosing
      // <details> (snippets/header-drawer.liquid). Neutralising Horizon's handler below
      // leaves that class with no owner: once anything adds it — a click landing before
      // this init, or a re-render restoring the `on:click` attribute — nothing ever takes
      // it off again and the icon stays an X for the rest of the session while this drawer
      // opens and closes normally. This drawer owns the class from here.
      var hzDetails = trigger ? trigger.closest('details') : null;
      var colsEl = drawer.querySelector('[data-pl-drawer-cols]');
      var backLabel = drawer.getAttribute('data-pl-back-label') || 'Back';
      var backIconTpl = drawer.querySelector('template[data-pl-back-icon]');
      var lastFocus = null;
      var resetTimer = null;

      var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var ANIMATING = 'pl-nav-drawer__col--animating';
      var ENTERING = 'pl-nav-drawer__col--entering';
      var SWAPPING = 'pl-nav-drawer__col--swapping';
      var LEAVING = 'pl-nav-drawer__col--leaving';
      // Fallbacks, not the schedule. `transitionend` is the real signal; these fire only
      // where it cannot — a background tab that never paints, a browser that drops the
      // event. Each is the CSS duration plus a few frames of slack.
      var ENTER_MS = 420;
      var LEAVE_MS = 320;
      var animating = [];
      var pinCount = 0;
      var pinFrame = null;

      function reducedMotion() {
        return !!(motionQuery && motionQuery.matches);
      }

      // The newest column lives at the end of the track, so "follow the drill" is just
      // "stay pinned to the end". Doing that on every frame of the column's own width
      // transition makes the scroll inherit that transition's curve and duration for
      // free. The old scrollToEnd() asked for `behavior: 'smooth'` instead — a
      // browser-chosen easing over a browser-chosen duration, which is a different
      // animation from the drawer's own no matter what the columns do. Where nothing
      // overflows, because the desktop panel simply grew instead, this is a no-op, so the
      // one call site covers both designs.
      function pinTrackToEnd() {
        colsEl.scrollLeft = colsEl.scrollWidth - colsEl.clientWidth;
      }

      function startPin() {
        pinCount += 1;
        if (pinFrame !== null) return;
        var step = function () {
          pinTrackToEnd();
          pinFrame = pinCount > 0 ? window.requestAnimationFrame(step) : null;
        };
        pinFrame = window.requestAnimationFrame(step);
      }

      function stopPin() {
        if (pinCount > 0) pinCount -= 1;
        if (pinCount === 0) pinTrackToEnd();
      }

      // Runs `done` exactly once, on whichever lands first: the column's own opacity
      // transition ending, or the fallback timer. Opacity is the property watched because
      // it is the one that changes in both directions and reports its own name — a
      // logical property would arrive as its PHYSICAL name and never match. Transitions
      // from descendants bubble here too (the rows carry a hover transition of their
      // own), so the target is checked as well.
      function trackColumn(col, ms, done) {
        var entry = { col: col, finished: false, timer: null, onEnd: null };
        entry.finish = function () {
          if (entry.finished) return;
          entry.finished = true;
          window.clearTimeout(entry.timer);
          col.removeEventListener('transitionend', entry.onEnd);
          var i = animating.indexOf(entry);
          if (i !== -1) animating.splice(i, 1);
          done();
          stopPin();
        };
        entry.onEnd = function (e) {
          if (e.target !== col || e.propertyName !== 'opacity') return;
          entry.finish();
        };
        entry.timer = window.setTimeout(entry.finish, ms);
        col.addEventListener('transitionend', entry.onEnd);
        animating.push(entry);
        startPin();
      }

      // Settle a column's in-flight transition NOW, running its completion work early. On
      // a leaving column that means it leaves the DOM immediately, which is the point:
      // every path that puts a new column in the track calls this on the old ones first,
      // so a column that is half way out can never still be occupying a slot when its
      // successor is appended after it. Iterated backwards because finish() splices.
      function settleAnimation(col) {
        for (var i = animating.length - 1; i >= 0; i--) {
          if (animating[i].col === col) animating[i].finish();
        }
      }

      function hardRemove(col) {
        settleAnimation(col);
        if (col.parentNode) col.parentNode.removeChild(col);
      }

      function leaveColumn(col) {
        settleAnimation(col);
        // Inert first: for the quarter second it spends shrinking it is still hit-testable
        // and still full of links, and a stray click on one of them would navigate.
        col.setAttribute('inert', '');
        col.classList.add(ANIMATING);
        col.classList.add(LEAVING);
        trackColumn(col, LEAVE_MS, function () {
          if (col.parentNode) col.parentNode.removeChild(col);
        });
      }

      // `swap` picks the start state: a column replacing a sibling's fades in at the width
      // the drawer already has, a column opening a new level grows from nothing.
      function addColumn(col, swap) {
        var startClass = swap ? SWAPPING : ENTERING;
        // The start state goes on before the column is in the document, so its first
        // resolved style is already the collapsed one and there is no frame in which the
        // drawer paints the column at full width.
        col.classList.add(ANIMATING);
        col.classList.add(startClass);
        colsEl.appendChild(col);

        if (reducedMotion()) {
          col.classList.remove(startClass);
          col.classList.remove(ANIMATING);
          pinTrackToEnd();
          return;
        }

        // FORCED REFLOW, deliberately, rather than a double requestAnimationFrame.
        // Reading offsetWidth flushes the pending style and layout here and now, so
        // removing the class on the very next statement is a change away from a resolved
        // start value and the transition has something to run from. A double rAF also
        // produces a start frame, but it spends one or two frames doing nothing first —
        // and this is a click, where those frames are precisely the dead beat that reads
        // as a snap. The cost is one synchronous layout per drill, which is nothing.
        void col.offsetWidth;
        col.classList.remove(startClass);
        trackColumn(col, ENTER_MS, function () {
          col.classList.remove(ANIMATING);
        });
      }

      function open() {
        if (resetTimer) { clearTimeout(resetTimer); resetTimer = null; }
        resetColumns();
        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        if (hzDetails) hzDetails.classList.add('menu-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        drawer.removeAttribute('inert');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        var closeBtn = drawer.querySelector('[data-pl-drawer-close]');
        if (closeBtn) closeBtn.focus();
      }

      function resetColumns() {
        drawer.querySelectorAll('.pl-nav-drawer__col').forEach(function (c) {
          if (c.getAttribute('data-pl-depth') !== '0') hardRemove(c);
        });
        drawer.querySelectorAll('.pl-nav-drawer__item--branch.is-active').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-expanded', 'false');
        });
      }

      function close() {
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        if (hzDetails) hzDetails.classList.remove('menu-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('inert', '');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        resetTimer = setTimeout(resetColumns, 500);
      }

      // `animate` says whether the columns going away are being DISMISSED or REPLACED.
      // Dismissed — the back arrow, or tapping the open branch shut — plays the leave.
      // Replaced — a different branch in the same column — does not: a leaving column
      // still occupies its slot in the flex track, so the drawer would sit a column too
      // wide for a quarter of a second and, on the phone, the pin would hold the wrong
      // column on screen. Anything already leaving is dropped outright either way; letting
      // a second leave start on it would restart its transition and leave it in the track
      // behind whatever comes next.
      function removeColumnsAfter(depth, animate) {
        drawer.querySelectorAll('.pl-nav-drawer__col').forEach(function (c) {
          if (parseInt(c.getAttribute('data-pl-depth'), 10) <= depth) return;
          if (animate && !reducedMotion() && !c.classList.contains(LEAVING)) leaveColumn(c);
          else hardRemove(c);
        });
      }

      function clearActiveInColumn(depth) {
        var col = drawer.querySelector('.pl-nav-drawer__col[data-pl-depth="' + depth + '"]');
        if (!col) return;
        col.querySelectorAll('.pl-nav-drawer__item--branch.is-active').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-expanded', 'false');
        });
      }

      function buildColumn(depth, title, fragment) {
        var col = document.createElement('div');
        col.className = 'pl-nav-drawer__col';
        col.setAttribute('data-pl-depth', depth);

        var head = document.createElement('button');
        head.type = 'button';
        head.className = 'pl-nav-drawer__col-head pl-nav-drawer__col-head--sub';
        head.setAttribute('data-pl-back', '');
        head.setAttribute('aria-label', backLabel);

        var icon = document.createElement('span');
        icon.className = 'pl-nav-drawer__back-icon';
        icon.setAttribute('aria-hidden', 'true');
        if (backIconTpl) icon.appendChild(backIconTpl.content.cloneNode(true));

        var titleEl = document.createElement('span');
        titleEl.className = 'pl-nav-drawer__col-title';
        titleEl.textContent = title;

        head.appendChild(icon);
        head.appendChild(titleEl);

        var body = document.createElement('div');
        body.className = 'pl-nav-drawer__col-body';
        var ul = document.createElement('ul');
        ul.className = 'pl-nav-drawer__list';
        ul.appendChild(fragment);
        body.appendChild(ul);

        col.appendChild(head);
        col.appendChild(body);
        return col;
      }

      // The rows of a column, copied from the branch's sublist in the page: each `<li>`
      // with its row control only, never its nested sublist. The originals stay the only
      // element carrying each `data-pl-col-id`, so the lookup in openBranch() can never
      // land on a copy, and a column holds its own rows and nothing deeper.
      function columnRows(sublist) {
        var fragment = document.createDocumentFragment();
        Array.prototype.forEach.call(sublist.children, function (li) {
          var row = li.cloneNode(false);
          row.appendChild(li.firstElementChild.cloneNode(true));
          fragment.appendChild(row);
        });
        return fragment;
      }

      // Returns false when the branch has no column to open, so the caller can leave a
      // branch link to the browser: the tap then goes to the branch's page instead of
      // doing nothing.
      function openBranch(button) {
        var colId = button.getAttribute('data-pl-branch');
        var sel = (window.CSS && CSS.escape) ? CSS.escape(colId) : colId;
        var sublist = colId ? drawer.querySelector('ul[data-pl-col-id="' + sel + '"]') : null;
        if (!sublist) return false;
        var depth = parseInt(button.closest('.pl-nav-drawer__col').getAttribute('data-pl-depth'), 10);

        // Collapse: the branch is being shut and nothing takes the column's place, so it
        // plays its leave. The button's own state is cleared NOW, synchronously, while
        // that column is still on screen for another quarter second — the DOM removal is
        // the only thing allowed to be late. Anything re-read during that window (a
        // re-tap on the branch, a second press) has to see "closed", or we are back to
        // the stale is-active the phone swipe used to cause, where the next tap took this
        // arm and tore the column down instead of sliding it in.
        if (button.classList.contains('is-active')) {
          removeColumnsAfter(depth, true);
          button.classList.remove('is-active');
          button.setAttribute('aria-expanded', 'false');
          return true;
        }

        // A column is already sitting in the slot this one is about to take, so the drawer
        // is not getting wider — the arriving column fades in at the width that is already
        // there. One already on its way out does not count: the panel is shrinking behind
        // it and this really is an arrival. Read before the removal, which is what empties
        // the slot.
        var stale = drawer.querySelector('.pl-nav-drawer__col[data-pl-depth="' + (depth + 1) + '"]');
        var swap = !!stale && !stale.classList.contains(LEAVING);

        removeColumnsAfter(depth, false);
        clearActiveInColumn(depth);
        button.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');

        addColumn(buildColumn(depth + 1, sublist.getAttribute('data-pl-col-title'), columnRows(sublist)), swap);
        return true;
      }

      // Same rule as the collapse arm: the branch un-marks itself immediately, the column
      // it opened animates out behind it. The pin follows the shrinking track, so the
      // phone slides back instead of snapping and the desktop panel closes up on the same
      // curve it opened on — no scrollToEnd() needed, the layout change carries it.
      function goBack(backBtn) {
        var depth = parseInt(backBtn.closest('.pl-nav-drawer__col').getAttribute('data-pl-depth'), 10);
        removeColumnsAfter(depth - 1, true);
        clearActiveInColumn(depth - 1);
      }

      if (trigger) {
        // Horizon's own `on:click="/toggle"` on this summary is stripped — and kept
        // stripped across the header's re-renders — from <head> in `pl-drawer`. Doing it
        // here instead was the search-freeze bug: this init runs seconds after load, and
        // the header re-render that follows put the attribute straight back.
        //
        // Clear a swap Horizon's handler may already have made. Without this the icon
        // cannot recover within the session, because the class is only ever added by that
        // handler.
        if (hzDetails) hzDetails.classList.remove('menu-open');
        // Horizon's handler used to set this as a side effect of opening its own drawer.
        // It no longer runs, so the state of the ☰/✕ toggle is ours to report.
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // The button is one control: it closes what it opened. It only ever called
          // open(), so a second press re-opened the already-open drawer instead of
          // dismissing it, and the icon promised a close that never came.
          if (drawer.classList.contains('is-open')) close();
          else open();
        }, true);
      }

      if (overlay) overlay.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      colsEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-pl-drawer-close]')) { close(); return; }
        if (e.target.closest('[data-pl-drawer-search]')) {
          close();
          var search = document.querySelector('.search-action button');
          if (search) search.click();
          return;
        }
        var back = e.target.closest('[data-pl-back]');
        if (back) { goBack(back); return; }
        var branch = e.target.closest('[data-pl-branch]');
        if (branch) {
          // A branch is a link to its own page (see pl-nav-drawer-item). A plain click
          // or Enter drills in instead of following it; Cmd/Ctrl/Shift-click is the
          // shopper asking for the page itself, in a new tab or window, so the browser
          // gets it untouched, as is any button but the main one. Alt is not in that
          // list: on a link it downloads the page. The `<button>` fallback has no page to
          // open, so it drills in on any click. The link is only held back once a column
          // has actually opened; with none to open, the tap still reaches the page.
          if (branch.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0)) return;
          if (openBranch(branch)) e.preventDefault();
          return;
        }
      });

      // Space activates a button but only scrolls on a link. A branch link carries
      // role="button", so it answers Space the way the `<button>` it replaced did: the
      // press only stops the scroll, the release acts, and only on the row that was
      // pressed — Tab away mid-press and the release does nothing. Acting on keydown
      // would toggle the column open and shut on every auto-repeat of a held key.
      var spacePressed = null;
      colsEl.addEventListener('keydown', function (e) {
        if (e.key !== ' ') return;
        var branch = e.target.closest('a[data-pl-branch]');
        if (!e.repeat) spacePressed = branch;
        if (branch) e.preventDefault();
      });
      colsEl.addEventListener('keyup', function (e) {
        if (e.key !== ' ') return;
        var branch = e.target.closest('a[data-pl-branch]');
        var pressed = spacePressed;
        spacePressed = null;
        if (!branch || branch !== pressed) return;
        e.preventDefault();
        openBranch(branch);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('pl-search');
    if (!root) return;

    var input = root.querySelector('[data-pl-search-input]');
    var clearBtn = root.querySelector('[data-pl-search-clear]');
    var lastTrigger = null;

    // The panel is a twin of the header capsule, so both its top and its rail
    // come from the capsule's own box rather than from numbers duplicated in
    // this file. `.header__columns` IS the pill (the grey capsule element,
    // pl-header.liquid:96); the header wrapper around it is wider and taller,
    // so measuring that instead would leave the two edges out of line.
    // Falls back to the wrapper, then to the CSS literals, if the pill is
    // absent — a future Horizon upgrade renaming the class must not strand the
    // overlay off-screen.
    function measureCapsule() {
      var pill = document.querySelector('.header__row--top .header__columns');
      var box = pill;
      if (!box) {
        box = document.getElementById('header-component') || document.querySelector('.header');
      }
      if (!box) return;

      var rect = box.getBoundingClientRect();
      root.style.setProperty('--pl-search-top', Math.max(0, Math.round(rect.bottom)) + 'px');

      if (pill) {
        var rail = Math.max(0, Math.round(rect.left));
        var right = Math.max(0, Math.round(window.innerWidth - rect.right));
        // One value drives both sides; the pill is symmetrically inset, and a
        // sub-pixel difference between the two would read as a crooked panel.
        root.style.setProperty('--pl-search-rail', Math.min(rail, right) + 'px');
      }
    }

    // Horizon can render the Search control TWICE — `search` and `drawer_search`
    // (header.liquid:131-148) — and hides one of the pair by width or by
    // menu-style (search.liquid:41-55). So "the trigger" is a set, and the member
    // that was pressed is not always the member still on screen afterwards.
    function triggers() {
      return document.querySelectorAll('.search-action button');
    }

    function setExpanded(state) {
      var list = triggers();
      for (var i = 0; i < list.length; i++) {
        list[i].setAttribute('aria-expanded', state ? 'true' : 'false');
      }
    }

    // Focusing a display:none element is a silent no-op that drops focus to
    // <body>, so a recorded trigger that has since been hidden — or that was
    // never visible, as when the drawer's Search pill synthesises its click on
    // whichever twin is first in the DOM — hands focus nowhere. Fall through to
    // the twin that is actually rendered.
    function focusTrigger(el) {
      var target = null;
      if (el && el.getClientRects && el.getClientRects().length > 0) target = el;
      if (!target) {
        var list = triggers();
        for (var i = 0; i < list.length; i++) {
          if (list[i].getClientRects().length > 0) {
            target = list[i];
            break;
          }
        }
      }
      if (target && typeof target.focus === 'function') target.focus();
    }

    function open(trigger) {
      lastTrigger = trigger || document.activeElement;
      measureCapsule();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      setExpanded(true);
      document.documentElement.classList.add('pl-search-locked');
      window.setTimeout(function () {
        if (input) input.focus();
      }, 70);
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      setExpanded(false);
      document.documentElement.classList.remove('pl-search-locked');
      if (input) input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      resetToDefault();
      focusTrigger(lastTrigger);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pl-search-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // ===== Typing state: predictive suggestions, collections and products =====
    // Query suggestions only exist on the JSON endpoint; collections + products are
    // rendered through the Section Rendering API so they reuse `pl-product-card`.
    var MIN_CHARS = 2;
    var DEBOUNCE_MS = 220;
    var SECTION_ID = 'pl-predictive-search';

    var defaultPanel = root.querySelector('[data-pl-search-default]');
    var resultsPanel = root.querySelector('[data-pl-search-results]');
    var suggestGroup = root.querySelector('[data-pl-search-suggestions]');
    var suggestList = root.querySelector('[data-pl-search-suggestlist]');
    var colsSlot = root.querySelector('[data-pl-search-collections-slot]');
    var prodsSlot = root.querySelector('[data-pl-search-products-slot]');
    var emptyMsg = root.querySelector('[data-pl-search-empty]');
    var seeAll = root.querySelector('[data-pl-search-seeall]');
    var statusEl = root.querySelector('[data-pl-search-status]');
    var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = root.getAttribute('data-search-url') || '/search';

    var debounceTimer = null;
    var controller = null;
    var requestToken = 0;

    function showDefault() {
      if (resultsPanel) resultsPanel.hidden = true;
      if (defaultPanel) defaultPanel.hidden = false;
      if (seeAll) seeAll.hidden = true;
      if (statusEl) statusEl.textContent = '';
    }

    // Cancel any in-flight predictive request and fall back to the trending panel.
    function resetToDefault() {
      window.clearTimeout(debounceTimer);
      requestToken++;
      if (controller) controller.abort();
      showDefault();
    }

    function gotoSearch(term) {
      var value = (term || '').trim();
      if (!value) return;
      window.location.href = searchUrl + '?q=' + encodeURIComponent(value) + '&type=product';
    }

    // Highlighting mirrors the Next.js `highlightSegments`: every typed word of 2+
    // characters is marked wherever it occurs, so "t shir" bolds "Shir" in
    // "T-Shirts". Shopify also returns a `styled_text` HTML string, but rendering
    // provider HTML is an injection surface — we re-derive from plain text and build
    // real text nodes instead.
    function highlightInto(el, text, term) {
      el.textContent = '';
      var source = text || '';
      var words = (term || '').trim().toLowerCase().split(/\s+/).filter(function (w) {
        return w.length >= 2;
      });
      if (!source || words.length === 0) {
        el.textContent = source;
        return;
      }
      var escaped = words.map(function (w) {
        return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      });
      var pattern = new RegExp('(' + escaped.join('|') + ')', 'ig');
      var last = 0;
      var match;
      while ((match = pattern.exec(source)) !== null) {
        if (match.index > last) {
          el.appendChild(document.createTextNode(source.slice(last, match.index)));
        }
        var mark = document.createElement('mark');
        mark.textContent = match[0];
        el.appendChild(mark);
        last = match.index + match[0].length;
        if (match[0].length === 0) pattern.lastIndex++;
      }
      if (last < source.length) {
        el.appendChild(document.createTextNode(source.slice(last)));
      }
    }

    function renderSuggestions(queries, term) {
      if (!suggestGroup || !suggestList) return 0;
      suggestList.textContent = '';
      var list = queries || [];
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var text = item && item.text ? item.text : '';
        if (!text) continue;
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pl-search__suggestion';
        btn.setAttribute('data-term', text);
        highlightInto(btn, text, term);
        li.appendChild(btn);
        suggestList.appendChild(li);
      }
      var count = suggestList.children.length;
      suggestGroup.hidden = count === 0;
      return count;
    }

    function injectSection(html, term) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-pl-search-payload]');
      var cols = payload ? payload.querySelector('[data-pl-search-collections]') : null;
      var prods = payload ? payload.querySelector('[data-pl-search-products]') : null;
      if (cols) {
        var links = cols.querySelectorAll('[data-pl-highlight]');
        for (var i = 0; i < links.length; i++) {
          highlightInto(links[i], links[i].textContent.trim(), term);
        }
      }
      if (colsSlot) {
        colsSlot.textContent = '';
        if (cols) colsSlot.appendChild(cols);
      }
      if (prodsSlot) {
        prodsSlot.textContent = '';
        if (prods) prodsSlot.appendChild(prods);
      }
      return { collections: !!cols, products: !!prods };
    }

    function run(term) {
      var token = ++requestToken;
      if (controller) controller.abort();
      controller = new AbortController();
      var signal = controller.signal;
      var encoded = encodeURIComponent(term);

      var queriesReq = fetch(
        suggestUrl + '.json?q=' + encoded + '&resources[type]=query&resources[limit]=8',
        { signal: signal }
      )
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });

      var sectionReq = fetch(
        suggestUrl +
          '?q=' + encoded +
          '&section_id=' + SECTION_ID +
          '&resources[type]=product,collection&resources[limit]=10',
        { signal: signal }
      )
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });

      Promise.all([queriesReq, sectionReq]).then(function (out) {
        if (token !== requestToken) return;

        var json = out[0];
        var queries =
          json && json.resources && json.resources.results
            ? json.resources.results.queries
            : [];
        var suggestionCount = renderSuggestions(queries, term);
        var injected = injectSection(out[1] || '', term);
        var hasAny = suggestionCount > 0 || injected.collections || injected.products;

        if (emptyMsg) {
          emptyMsg.hidden = hasAny;
          if (!hasAny) emptyMsg.textContent = emptyMsg.getAttribute('data-label-empty') || '';
        }
        if (seeAll) seeAll.hidden = !injected.products;
        if (defaultPanel) defaultPanel.hidden = true;
        if (resultsPanel) resultsPanel.hidden = false;
        if (statusEl) statusEl.textContent = statusEl.getAttribute('data-label-done') || '';
      });
    }

    function onType() {
      if (clearBtn) clearBtn.hidden = input.value.length === 0;
      var term = input.value.trim();
      window.clearTimeout(debounceTimer);
      if (term.length < MIN_CHARS) {
        requestToken++;
        if (controller) controller.abort();
        showDefault();
        return;
      }
      if (statusEl) statusEl.textContent = statusEl.getAttribute('data-label-loading') || '';
      debounceTimer = window.setTimeout(function () { run(term); }, DEBOUNCE_MS);
    }

    if (input) {
      input.addEventListener('input', onType);
    }

    if (suggestList) {
      suggestList.addEventListener('click', function (e) {
        var btn = e.target.closest('.pl-search__suggestion');
        if (!btn) return;
        gotoSearch(btn.getAttribute('data-term'));
      });
    }

    if (seeAll) {
      seeAll.addEventListener('click', function () {
        gotoSearch(input ? input.value : '');
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) {
          input.value = '';
          input.focus();
        }
        clearBtn.hidden = true;
        resetToDefault();
      });
    }

    window.addEventListener('resize', function () {
      if (root.classList.contains('is-open')) measureCapsule();
    });

    // Trigger interception. Horizon's Search buttons open the predictive-search modal
    // via a document-level `on:click` capture delegation that fires before any element
    // listener, so stopPropagation is too late. That attribute is stripped — and kept
    // stripped across the header's re-renders — from <head> in `pl-drawer`; stripping it
    // here instead ran too late to be reliable. This listener only has to open the
    // overlay. It covers the drawer's Search pill too: that pill synthesises a click on
    // the same header button, which bubbles here.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.search-action button');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      // The Search control is one control: it closes what it opened, the way the
      // hamburger already does (pl-nav-drawer.liquid:729-737).
      //
      // Only a REAL press toggles. The drawer's Search pill reaches this listener
      // by synthesising a click on the same button (pl-nav-drawer.liquid:750-751),
      // and `HTMLElement.click()` dispatches an untrusted event — which is the
      // honest signal here, because that click is a request FOR search rather than
      // a press of the search control. Without the distinction, opening the drawer
      // over an already-open overlay (the pill stays clickable now, see the
      // pointer-events note in the stylesheet) and picking Search would dismiss
      // the very thing it asks for.
      if (e.isTrusted && root.classList.contains('is-open')) {
        // Return focus to the button actually pressed, not to whichever twin
        // opened the overlay the first time.
        lastTrigger = trigger;
        close();
        return;
      }
      open(trigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-sticky-atc"] && !Shopify.designMode) return;
  try {
    class PlStickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.productId = this.dataset.productId;
      this.addText = this.dataset.addText || '';
      this.soldOutText = this.dataset.soldOutText || '';
      this.addedText = this.dataset.addedText || '';

      this.button = this.querySelector('[data-pl-sticky-add]');
      this.labelEl = this.querySelector('[data-pl-sticky-label]');
      this.sizeFields = Array.from(this.querySelectorAll('.pl-sticky-atc__size'));

      // Mirrors the Next.js useIntersection initial state: assume the buy row is
      // on screen so the island never flashes before the first observer callback.
      this._buyInView = true;
      // The phone's own flag. `false` on load says "the button has not gone under the
      // header yet", which is the truth on first paint and keeps the island off the
      // gallery without relying on an observer callback landing first.
      this._buyPassed = false;
      this._relatedCovering = false;
      this._frame = 0;
      // Held rather than re-created per frame: `_apply` runs on every rAF-throttled scroll.
      this._phone = window.matchMedia('(max-width: 767px)');
      this._abort = new AbortController();
      const signal = this._abort.signal;

      this._locate();

      this.querySelectorAll('[data-pl-size-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', this._onTriggerClick, { signal });
      });
      this.querySelectorAll('[data-pl-size-option]').forEach((option) => {
        option.addEventListener('click', this._onSizeSelect, { signal });
      });
      const colorTrigger = this.querySelector('[data-pl-color-trigger]');
      if (colorTrigger) colorTrigger.addEventListener('click', this._onTriggerClick, { signal });
      if (this.button) this.button.addEventListener('click', this._onAdd, { signal });

      document.addEventListener('mousedown', this._onDocumentDown, { signal });
      document.addEventListener('keydown', this._onKeyDown, { signal });

      if (this.section) {
        this.section.addEventListener('shopify:product:select', this._onProductSelect, { signal });
      }
      document.addEventListener('shopify:cart:lines-update', this._onCartSettle, { signal });
      document.addEventListener('shopify:cart:error', this._onCartSettle, { signal });

      this._setupObservers();
      this._syncButton();
    }

    disconnectedCallback() {
      this._abort.abort();
      if (this._buyObserver) this._buyObserver.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._addedTimer) clearTimeout(this._addedTimer);
    }

    _locate() {
      const scope = this.section || document;
      this.mainForm =
        scope.querySelector('product-form-component[data-product-id="' + this.productId + '"]') ||
        scope.querySelector('product-form-component');
      this.mainButton = this.mainForm ? this.mainForm.querySelector('[ref="addToCartButton"]') : null;
      this.mainPicker =
        scope.querySelector('variant-picker[data-product-id="' + this.productId + '"]') ||
        scope.querySelector('variant-picker');
    }

    _setupObservers() {
      const scope = this.section || document;
      this.buyTarget =
        scope.querySelector('.buy-buttons-block') ||
        scope.querySelector('add-to-cart-component') ||
        this.mainButton;

      if (this.buyTarget && 'IntersectionObserver' in window) {
        this._buyObserver = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          this._buyInView = entry.isIntersecting;
          this._apply();
        });
        this._buyObserver.observe(this.buyTarget);
      }

      // Rect-measured, NOT an IntersectionObserver — see the doc header.
      this.related = document.querySelector('.pl-related, [data-testid="product-recommendations-section"]');

      // Unconditional, where this used to belong to the related section alone: the phone
      // rule measures the buy row against the header every frame, so the listener now has
      // two owners and cannot be gated on either one existing.
      window.addEventListener('scroll', this._onScroll, { passive: true, signal: this._abort.signal });
      window.addEventListener('resize', this._onScroll, { signal: this._abort.signal });

      this._measure();
    }

    _onScroll = () => {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        this._measure();
      });
    };

    // Both measurements in one pass, ending in a single `_apply`. They are read together
    // because they answer one question between them, and a shared exit keeps a frame from
    // toggling the class twice on its way to the state it settles at.
    _measure() {
      if (this.related) {
        const rect = this.related.getBoundingClientRect();
        const vh = window.innerHeight;
        this._relatedCovering = rect.top < vh && rect.bottom > vh;
      }
      // Gated on the phone rule actually being in play, so desktop — which reads
      // `_buyInView` and never `_buyPassed` — pays nothing for a measurement it discards.
      if (this.buyTarget && this._phone.matches) {
        this._buyPassed = this.buyTarget.getBoundingClientRect().bottom <= this._headerBottom();
      }
      this._apply();
    }

    // The occlusion line: the bottom of the visible header capsule. Read live rather than
    // stored, so it follows the pill as the announcement bar hides and the pill rises to
    // `top: 0` — and so no copy of the header's height exists here to drift out of sync
    // with `--pl-announcement-h`. Clamped at 0 for the case where the whole sticky chrome
    // has scrolled off (it does at desktop widths, where the rect bottom goes negative),
    // which would otherwise hand back a threshold below the viewport.
    _headerBottom() {
      // Cached across frames, but re-resolved if the node goes away — the theme editor
      // re-renders the header section on every setting change, which detaches this one.
      if (!this._headerEl || !this._headerEl.isConnected) {
        this._headerEl =
          document.querySelector('#header-component .header__row--top') ||
          document.querySelector('#header-component');
      }
      if (!this._headerEl) return 0;
      return Math.max(0, this._headerEl.getBoundingClientRect().bottom);
    }

    _apply() {
      // Phone: the island appears only once the real button is occluded. Desktop: the
      // ported Next.js rule, unchanged. `this.buyTarget` missing drops every width back to
      // the desktop rule — see the doc header for why that is the safer fallback.
      const usePhoneRule = this.buyTarget && this._phone.matches;
      const buttonGone = usePhoneRule ? this._buyPassed : !this._buyInView;
      const show = buttonGone && !this._relatedCovering;
      if (show === this._shown) return;
      this._shown = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        this.removeAttribute('inert');
      } else {
        this.setAttribute('inert', '');
        this._closeMenus();
      }
    }

    _onTriggerClick = (event) => {
      const trigger = event.currentTarget;
      const field = trigger.closest('.pl-sticky-atc__field');
      const menu = field ? field.querySelector('[role="listbox"]') : null;
      if (!menu) return;
      const open = menu.hasAttribute('hidden');
      this._closeMenus();
      if (open) {
        menu.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
      }
    };

    _closeMenus() {
      this.querySelectorAll('[role="listbox"]').forEach((menu) => menu.setAttribute('hidden', ''));
      this.querySelectorAll('[aria-expanded]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }

    _onDocumentDown = (event) => {
      if (this.contains(event.target)) return;
      this._closeMenus();
    };

    _onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      this._closeMenus();
    };

    _onSizeSelect = (event) => {
      const option = event.currentTarget;
      if (option.disabled) return;
      const field = option.closest('.pl-sticky-atc__size');
      const trigger = field ? field.querySelector('[data-pl-size-trigger]') : null;
      const name = trigger ? trigger.dataset.optionName : '';
      const value = option.dataset.value;
      this._closeMenus();
      if (!this.mainPicker || !name) return;

      const input = this.mainPicker.querySelector(
        'input[data-option-name="' + this._cssEscape(name) + '"][value="' + this._cssEscape(value) + '"]'
      );
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this._syncSizes();
    };

    _onProductSelect = (event) => {
      if (event.target && event.target.closest && event.target.closest('product-card')) return;
      const promise = event.promise;
      if (!promise || typeof promise.then !== 'function') {
        this._locate();
        this._syncSizes();
        this._syncButton();
        return;
      }
      promise
        .then((result) => {
          const detail = result && result.detail;
          this._locate();
          this._syncSizes();
          this._syncButton(detail ? detail.resource : undefined);
        })
        .catch(() => {});
    };

    // Mirrors the Next.js `availability` map: per-value stock comes straight off
    // the live variant-picker inputs, which Horizon re-renders on every change.
    _syncSizes() {
      if (!this.mainPicker) return;
      this.sizeFields.forEach((field) => {
        const trigger = field.querySelector('[data-pl-size-trigger]');
        const current = field.querySelector('[data-pl-size-current]');
        if (!trigger) return;
        const name = trigger.dataset.optionName;
        const checked = this.mainPicker.querySelector(
          'input[data-option-name="' + this._cssEscape(name) + '"]:checked'
        );
        if (checked && current) current.textContent = checked.value;

        field.querySelectorAll('[data-pl-size-option]').forEach((option) => {
          const value = option.dataset.value;
          const input = this.mainPicker.querySelector(
            'input[data-option-name="' + this._cssEscape(name) + '"][value="' + this._cssEscape(value) + '"]'
          );
          const available = input ? input.dataset.optionAvailable !== 'false' : true;
          const selected = !!checked && checked.value === value;
          option.disabled = !available;
          option.classList.toggle('is-disabled', !available);
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      });
    }

    _syncButton(resource) {
      if (!this.button) return;
      let disabled;
      if (resource !== undefined) {
        disabled = resource === null || resource.available === false;
      } else if (this.mainButton) {
        disabled = this.mainButton.disabled;
      }
      if (disabled === undefined) return;
      this.button.disabled = disabled;
      if (this.labelEl) this.labelEl.textContent = disabled ? this.soldOutText : this.addText;
    }

    _onAdd = () => {
      if (!this.mainButton || this.mainButton.disabled || this.button.disabled) return;
      this._closeMenus();
      this.button.dataset.loading = 'true';
      this.mainButton.dataset.puppet = 'true';
      this.mainButton.click();
    };

    _onCartSettle = (event) => {
      const settle = () => {
        if (this.mainButton) this.mainButton.dataset.puppet = 'false';
        if (!this.button) return;
        this.button.removeAttribute('data-loading');
        if (this.labelEl && !this.button.disabled) {
          this.labelEl.textContent = this.addedText;
          if (this._addedTimer) clearTimeout(this._addedTimer);
          this._addedTimer = setTimeout(() => {
            if (this.labelEl && !this.button.disabled) this.labelEl.textContent = this.addText;
          }, 1500);
        }
      };
      if (event && event.promise && typeof event.promise.then === 'function') {
        event.promise.finally(settle);
      } else {
        settle();
      }
    };

    _cssEscape(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
      return String(value).replace(/["\\\]]/g, '\\$&');
    }
  }

  if (!customElements.get('pl-sticky-atc')) {
    customElements.define('pl-sticky-atc', PlStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-stock-guard"] && !Shopify.designMode) return;
  try {
    class PlStockGuard extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.productId = this.dataset.productId;
      this.soldOutText = this.dataset.soldOutText || '';

      this.limits = {};
      this.cartQuantities = {};
      const payload = this.querySelector('script[type="application/json"]');
      if (payload) {
        try {
          const data = JSON.parse(payload.textContent);
          this.limits = data.limits || {};
          this.cartQuantities = data.cart || {};
        } catch (error) {
          /* leave the guard inert rather than mis-locking the button */
        }
      }

      this._abort = new AbortController();
      const signal = this._abort.signal;

      if (this.section) {
        this.section.addEventListener('shopify:product:select', this._onProductSelect, { signal });
      }
      document.addEventListener('shopify:cart:lines-update', this._onCartUpdate, { signal });

      this._apply();
    }

    disconnectedCallback() {
      this._abort.abort();
    }

    _form() {
      const scope = this.section || document;
      return (
        scope.querySelector('product-form-component[data-product-id="' + this.productId + '"]') ||
        scope.querySelector('product-form-component')
      );
    }

    _selectedVariantId() {
      const form = this._form();
      const input = form ? form.querySelector('input[name="id"]') : null;
      return input && input.value ? String(input.value) : null;
    }

    _onProductSelect = (event) => {
      if (event.target && event.target.closest && event.target.closest('product-card')) return;
      const promise = event.promise;
      if (promise && typeof promise.then === 'function') {
        promise.then(() => this._apply()).catch(() => {});
      } else {
        this._apply();
      }
    };

    _onCartUpdate = (event) => {
      const promise = event.promise;
      if (!promise || typeof promise.then !== 'function') {
        this._refresh();
        return;
      }
      promise
        .then((result) => {
          const items = result && result.detail && result.detail.items;
          if (Array.isArray(items)) {
            this._setCartQuantities(items);
            this._apply();
            return;
          }
          return this._refresh();
        })
        .catch(() => this._refresh());
    };

    _refresh() {
      const routes = window.Theme && window.Theme.routes;
      const cartUrl = (routes && routes.cart_url) || '/cart';
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && Array.isArray(cart.items)) this._setCartQuantities(cart.items);
          this._apply();
        })
        .catch(() => {});
    }

    _setCartQuantities(items) {
      const next = {};
      items.forEach((item) => {
        const id = String(item.variant_id);
        next[id] = (next[id] || 0) + (item.quantity || 0);
      });
      this.cartQuantities = next;
    }

    _apply() {
      const variantId = this._selectedVariantId();
      const limit = variantId ? this.limits[variantId] : undefined;
      const inCart = variantId ? this.cartQuantities[variantId] || 0 : 0;
      const atMax = typeof limit === 'number' && inCart >= limit;

      const form = this._form();
      this._lockButton(form ? form.querySelector('[ref="addToCartButton"]') : null, atMax);
      this._lockStickyButton(document.querySelector('[data-pl-sticky-add]'), atMax);

      if (this.section) {
        if (atMax) {
          this.section.dataset.plStockLocked = 'true';
        } else {
          delete this.section.dataset.plStockLocked;
        }
      }
    }

    _labelNode(button) {
      for (const node of button.childNodes) {
        if (node.nodeType === 3 && node.nodeValue.trim() !== '') return node;
      }
      return null;
    }

    _lockButton(button, atMax) {
      if (!button) return;
      if (atMax) {
        const node = this._labelNode(button);
        if (node) {
          if (button.dataset.plStockLocked !== 'true') button.dataset.plStockLabel = node.nodeValue;
          node.nodeValue = this.soldOutText;
        }
        button.dataset.plStockLocked = 'true';
        button.disabled = true;
        return;
      }
      if (button.dataset.plStockLocked !== 'true') return;
      const node = this._labelNode(button);
      if (node && button.dataset.plStockLabel !== undefined) node.nodeValue = button.dataset.plStockLabel;
      delete button.dataset.plStockLabel;
      delete button.dataset.plStockLocked;
      button.disabled = false;
    }

    _lockStickyButton(button, atMax) {
      if (!button) return;
      const label = button.querySelector('[data-pl-sticky-label]');
      if (atMax) {
        if (label) {
          if (button.dataset.plStockLocked !== 'true') button.dataset.plStockLabel = label.textContent;
          label.textContent = this.soldOutText;
        }
        button.dataset.plStockLocked = 'true';
        button.disabled = true;
        return;
      }
      if (button.dataset.plStockLocked !== 'true') return;
      if (label && button.dataset.plStockLabel !== undefined) label.textContent = button.dataset.plStockLabel;
      delete button.dataset.plStockLabel;
      delete button.dataset.plStockLocked;
      button.disabled = false;
    }
  }

  if (!customElements.get('pl-stock-guard')) {
    customElements.define('pl-stock-guard', PlStockGuard);
  }
  } catch(e) { console.error(e); }
})();

})();
